/**********
* Parallax
* --------
*
* Parallax object that is being called by the bindEvents from ScrollEvents
*
*/
var Parallax = /** @class */ (function () {
    function Parallax(pObj) {
        this.parallaxName = pObj.name;
        this.parallaxType = pObj.type;
        this.parallaxElement = pObj.element;
        this.scrollValues = pObj.scrollValues;
        this.parallaxValues = pObj.parallaxValues;
        if (pObj.unit)
            this.parallaxUnit = pObj.unit;
        if (pObj.colors)
            this.colors = pObj.colors;
        this.findEquation(pObj.scrollValues, pObj.parallaxValues);
    }
    /**************
     * findEquation
     * ------------
     *
     * Get equations coeficients to transform scroll difference into the range of value difference
     *
     * @param scrollValues
     * @param parallaxValues
     */
    Parallax.prototype.findEquation = function (scrollValues, parallaxValues) {
        this.a = (parallaxValues.max - parallaxValues.min) / (scrollValues.max - scrollValues.min);
        this.b = parallaxValues.min - this.a * scrollValues.min;
        this.updateStatus($(window).scrollTop());
    };
    /**********
     * getValue
     * --------
     *
     * Gets new value from equation range with scroll value
     *
     * @param value
     */
    Parallax.prototype.getValue = function (value) {
        this.curentValue = this.a * value + this.b;
        return this.curentValue;
    };
    /*************
     * applyStatus
     * -----------
     *
     * Returns the value calculated from the range or min/max if above limits
     *
     * @param scroll
     * @return newValue
     */
    Parallax.prototype.applyStatus = function (scroll) {
        var newValue;
        if (scroll >= this.scrollValues.min && scroll <= this.scrollValues.max) {
            newValue = this.getValue(scroll).toString();
        }
        else if (scroll < this.scrollValues.min) {
            newValue = this.parallaxValues.min.toString();
        }
        else {
            if (this.curentValue != this.parallaxValues.max) {
                newValue = this.parallaxValues.max.toString();
            }
        }
        return newValue;
    };
    /**************
     * updateStatus
     * ------------
     *
     * Called by the ScrollEvent with the new scroll value and does parallaxType action
     *
     * @param scroll
     */
    Parallax.prototype.updateStatus = function (scroll) {
        switch (this.parallaxType) {
            case 'opacity': {
                this.parallaxElement.css(this.parallaxType, this.applyStatus(scroll));
                break;
            }
            case 'background-position-y': {
                var unit = this.parallaxUnit ? this.parallaxUnit : 'px';
                this.parallaxElement.css(this.parallaxType, this.applyStatus(scroll) + unit);
                break;
            }
            case 'background-position-x': {
                var unit = this.parallaxUnit ? this.parallaxUnit : 'px';
                this.parallaxElement.css(this.parallaxType, this.applyStatus(scroll) + unit);
                break;
            }
            case 'background-color': {
                this.parallaxElement.css(this.parallaxType, "rgba(" + this.colors[0] + "," + this.colors[1] + "," + this.colors[2] + ", " + this.applyStatus(scroll) + ")");
                break;
            }
            case 'translateX': {
                var unit = this.parallaxUnit ? this.parallaxUnit : 'px';
                this.parallaxElement.css('transform', "translateX(" + this.applyStatus(scroll) + unit + ")");
                break;
            }
            case 'translateY': {
                var unit = this.parallaxUnit ? this.parallaxUnit : 'px';
                this.parallaxElement.css('transform', "translateY(" + this.applyStatus(scroll) + unit + ")");
                break;
            }
            case 'translateYnoX': {
                var unit = this.parallaxUnit ? this.parallaxUnit : 'px';
                this.parallaxElement.css('transform', "translate(-50%, " + this.applyStatus(scroll) + unit + ")");
                break;
            }
        }
    };
    return Parallax;
}());
/**************
 * ScrollEvents
 * ------------
 *
 * ScrollEvents save the Paralax Objects and binds all of them to the Window scroll event
 *
 */
var ScrollEvents = /** @class */ (function () {
    function ScrollEvents(className) {
        this.parallaxes = [];
        this.className = className;
    }
    /*************
     * addParallax
     * -----------
     *
     * Adds a Parallax event to the ScrollEvent, before it is binded
     *
     * @param event
     */
    ScrollEvents.prototype.addParallax = function (event) {
        this.parallaxes.push(new Parallax(event));
    };
    /*************
     * getParallax
     * -----------
     *
     * Retrieve the Parallax Object
     *
     * @param name
     */
    /*  getParallax(name: string): Parallax {
          return this.parallaxes.find((element: Parallax):boolean => {
              return element.parallaxName == name;
          });
      }*/
    /************
     * bindEvents
     * ----------
     *
     * Binds all events that have been added to the ScrollEvent Class to the Window scroll event,
     * and calls their updateStatus function
     *
     */
    ScrollEvents.prototype.bindEvents = function () {
        var _this = this;
        $(window).on('scroll', function (event) {
            var scroll = $(event.currentTarget).scrollTop();
            _this.parallaxes.forEach(function (element) {
                element.updateStatus(scroll);
            });
        });
    };
    return ScrollEvents;
}());
